import { render, staticRenderFns } from "./Area.vue?vue&type=template&id=485aec03&scoped=true&"
import script from "./Area.vue?vue&type=script&setup=true&lang=js&"
export * from "./Area.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Area.vue?vue&type=style&index=0&id=485aec03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485aec03",
  null
  
)

export default component.exports